import actions from "./actions";

const reducer = (state, action) => {
	switch (action.type) {
		case actions.SET_GROUP_INFORMATION: {
			return {
				...state,
				groupInformation: action.payload
			};
		}
		case actions.SET_LOCATION_INFORMATION: {
			return {
				...state,
				locationInformation: action.payload
			};
		}
		case actions.SET_CURRENT_GROUP: {
			return {
				...state,
				currentGroup: action.payload
			};
		}
		default:
			throw new Error("Unexpected action: Group Context");
	}
};

export default reducer;
